import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type DevModeState = {
  isDevMode: boolean;
  enable: () => void;
  disable: () => void;
  toggle: () => void;
};

export const useDevModeStore = create<DevModeState>()(
  devtools(
    persist(
      immer((set) => ({
        isDevMode: false,
        enable: () =>
          set((state) => {
            state.isDevMode = true;
          }),
        disable: () =>
          set((state) => {
            state.isDevMode = false;
          }),
        toggle: () =>
          set((state) => {
            state.isDevMode = !state.isDevMode;
          }),
      })),
      {
        name: 'dev-mode-storage',
      }
    ),
    { name: 'DevModeStore' }
  )
);
